<template>
  <div :class="$style.outer" v-loading="!!loading && !tableLoading">
    <template v-if="detail">
      <div :class="$style.top_warp">
        <div :class="$style.top">
          <div :class="$style.top__info">
            <template v-if="routeFrom == 'mark' && !(detail.customers && detail.customers.length)">
              <template v-if="comfirmTableList[0]">
                <span>{{ comfirmTableList[0].wx_nickname || '--' }}</span>
                <span>{{ comfirmTableList[0].union_id || '--' }}</span>
                <span>{{ comfirmTableList[0].correlation_user || '--' }}</span>
              </template>
            </template>
            <template v-else>
              <span v-for="(item, index) in topConfig" :key="index">
                <span>{{ item.label }} </span>
                <el-select
                  v-if="item.type === 'select' && ((item.options && item.options.length > 1) || !detail[item.prop])"
                  :class="item.class"
                  v-model="detail[item.prop]" 
                  v-on="item.event"
                  placeholder=" "
                  filterable
                >
                  <el-option
                    v-for="(opt, index) in item.options"
                    :key="index"
                    :label="opt[item.labelKey]"
                    :value="opt[item.valueKey]">
                  </el-option>
                </el-select>
                <span v-else>{{ getKeyValue(item.key, item.data) }}</span>
              </span>
            </template>
          </div>
          <div :class="$style.top__right" v-if="routeFrom != 'mark'">
            <span>稽查任务关联：</span>
            <span v-if="alreadyJudge || !hasEditPermission">
              <span v-if="alreadyCancel">已取消</span>
              <span v-else>{{ (detail.inspector ? (detail.inspector.realname ||'--') : '--') }}</span>
            </span>
            <template v-else>
              <span v-if="!inspectorEdit" :class="$style.editText" @click="onInspectorEdit">
                <span>{{inspectorsMap[inspector] ? inspectorsMap[inspector].realname : (detail.inspector ? (detail.inspector.realname ||'--') : '--')}}</span>
                <i class="el-icon-edit"></i>
              </span>
              <template v-else>
                <!-- @change="onInspectorChange"  -->
                <el-select ref="editSelect" v-model="inspector" placeholder=" " style="width: 120px;" filterable >
                  <el-option
                    v-for="(value, key) in inspectorsMap"
                    :key="key"
                    :label="value.realname"
                    :value="key * 1">
                  </el-option>
                </el-select>
                <i class="el-icon-check" :class="$style.editText" @click="onInspectorChange"></i>
              </template>
            </template>
          </div>
        </div>
        <div :class="$style.top_assist_sales" v-if="detail.assist_sales && detail.assist_sales.length">
          <span :class="$style.label">协作开单人</span>
          <div>
            <span class="ml15" v-for="(item, index) in detail.assist_sales" :key="index">{{ item }}</span>
          </div>
        </div>
      </div>
      <div :class="$style.module">
        <div :class="$style.moduleTitle">违规内容</div>
        <ContentLine
          :list="chatList"
          :confirmTime="detail.confirm_time"
          :editable="inspectionFromEditable && hasEditPermission"
        />
      </div>
      <div :class="$style.module">
        <div :class="$style.moduleTitle">核查关系链确认</div>
        <ComfirmTable
          :list="comfirmTableList"
          :detail="detail"
          :inspector="inspector"
          :routeFrom="routeFrom"
          @update="onUpdateTable"
          :editable="inspectionFromEditable && hasEditPermission"
        />
      </div>
      <!-- :curatorsOptions="curatorsOptions" -->
      <DetailBottom 
        v-if="!alreadyCancel"
        :hasEditPermission="hasEditPermission"
        :alreadyJudge="alreadyJudge"
        :detail="detail"
        :validOptions="validOptions"
        :comfirmTableList="comfirmTableList"
        :chatList="chatList"
        @back="backToList"
        @update="init"
        @changeJudgeEditable="inspectionFromEditable = $event"
      />
    </template>
  </div>
</template>

<script>
import ComfirmTable from './ComfirmTable/index'
import DetailBottom from './DetailBottom.vue'
import ContentLine from './ContentLine/index'
import { hasPermission } from '@/permission/index'
import { 
  getLiveInspectors,
  getInspectDetail,
  modifyInspectOrder,
  violationTagDetail,
  getRelationList,
  violationChatDetail
} from './api'

export default {
  components: { ComfirmTable, DetailBottom, ContentLine },
  data () {
    return {
      loading: 0,
      tableLoading: false,
      detail: null,
      inspector: undefined,
      inspectorsMap: {},
      inspectorEdit: false,
      inspectionFromEditable: true,
      comfirmTableList: [],
      chatList: [],
      orders: [],
    }
  },
  provide() {
    return {
      detail: () => this.detail,
    };
  },
  computed: {
    hasEditPermission() {
      return hasPermission('Global_Button_SmallCompliance')
    },
    routeFrom() {
      return this.$route.query.from
    },
    id () {
      return this.$route.params.id
    },
    alreadyJudge () {
      //status 为0或者没有的话
      return !!this.detail?.status
    },
    alreadyCancel () {
      return this.detail?.status === 3
    },
    topConfig() {
      let isMark = this.routeFrom == 'mark'
      let getOptions = () => ([
        {
          label: '客户姓名',
          key: 'customer_name'
        },
        {
          label: '客户编号',
          key: 'gold_coding',
          type: isMark ? 'select' : '',
          prop: 'customer_id',
          class: 'w100',
          options: this.detail?.customers || [],
          labelKey: 'gold_coding',
          valueKey: 'id',
          event: {
            change: (val) => {
              this.getDetail({customer_id: val})
              this.getChatDetail()
            }
          }
        },
        {
          label: '关联产品',
          key: 'product_name',
          type: isMark ? 'select' : '',
          prop: 'order_id',
          class: 'w200',
          options: this.orders || [],
          labelKey: 'product_name',
          valueKey: 'id',
          event: {
            change: (val) => {
              this.getDetail({
                customer_id: this.detail.customer_id,
                order_id: val,
              })
              this.getChatDetail()
            }
          }
        },
        {
          label: '服务开通日期',
          key: 'confirm_time'
        },
        {
          label: '关联员工',
          key: '0.correlation_user',
          data: this.comfirmTableList,
          if: () => isMark
        },
        {
          label: '成单员工',
          key: 'khUser.full_name',
          if: () => !isMark
        },
      ])
      return getOptions().filter(a => !a.if || a.if())
    },
    validOptions() {
      return this.comfirmTableList.filter(item => item.inspect_status === 1)
    },
    contactIds() {
      let arr = this.comfirmTableList.map(item => item.contact_id)
      return [...new Set(arr)]
    },
    employeeIds() {
      let arr = this.comfirmTableList.map(item => item.employee_id)
      return [...new Set(arr)]
    }
  },
  async mounted() {
    this.getInspectorsMap()
    this.init()
  },
  methods: {
    async init () {
      let params = {}
      if (this.detail && this.routeFrom === 'mark') {
        params.customer_id = this.detail.customer_id
        params.order_id = this.detail.order_id
      }
      await this.getDetail(params)
      this.getTableList()
    },
    async getDetail (params = {}) {
      this.loading++
      try {
        let method = getInspectDetail
        if (this.routeFrom === 'mark') {
          method = violationTagDetail
        }
        let {code, msg, data} = await method({ id: this.id, ...params })
        if (code !== 200) {
          throw new Error(msg)
        }
        if (!data) {
          throw new Error('没有查询到当前记录')
        }
        this.$set(this, 'detail', data)
        this.detail.customer_id = data.customer_id || undefined
        this.detail.order_id = data.order_id || undefined
        this.inspector = this.detail?.inspector?.id
        this.inspectionFromEditable = !this.alreadyJudge
        this.orders = data.customers?.find(item => item.id === data.customer_id)?.orders || []
      } catch (e) {
        this.$message.error(e.message || e)
        this.$router.push({
          name: 'InspectionTasks'
        })
      } finally {
        this.loading--
      }
    },
    getKeyValue (keyPath, data) {
      let value = keyPath.split('.').reduce((o, p) => o && o[p], data || this.detail)
      return value || '--'
    },
    onUpdateTable () {
      if (this.routeFrom != 'mark') {
        this.tableLoading = true
        this.getTableList()
      }
    },
    async getTableList() {
      let method = this.routeFrom == 'mark' ? 'getMarkTableList' : 'getDefaultTableList'
      await this[method]()
      if (! this.comfirmTableList?.length) return
      this.getChatDetail()
    },
    getMarkTableList () {
      if (this.comfirmTableList?.length) return
      let list = []
      const obj = localStorage.getItem('InspectionTasks_Mark_Row');
      if (obj) {
        let row = JSON.parse(obj)
        if (row.no != this.id) {
          this.$router.push({name: 'InspectionTasks'})
          localStorage.removeItem('InspectionTasks_Mark_Row')
          return
        }
        row.inspect_status = 0
        // row.inspect_status_lable = '未稽查'
        row.index = 1
        list.push(row)
      }
      this.comfirmTableList = list
    },
    async getDefaultTableList () {
      this.loading++
      try {
        const { code, data } = await getRelationList({
          gold_coding: this.detail.gold_coding,
          id: this.detail.id,
        })
        if (code !== 200) {
          this.comfirmTableList = []
          return
        }

        this.comfirmTableList = data?.map((item,index) => {
          item.index = index + 1
          item.contact_name = item.contact?.name
          item.union_id = item.contact?.unionid
          item.employee_corpName =  item.employee?.corpName + ' ' + item.employee?.wxUserId
          item.employee_fullName = item.employee?.fullName
          item.relation_firstAddTime = item.relation?.firstAddTime
          item.relation_lastStatus_text = item.relation?.lastStatus?.text
          item.inspect_status = item.inspect?.status?.value
          item.inspect_status_lable = item.inspect?.status?.lable
          item.inspect_user_realname = item.inspect?.user?.realname
          item.inspect_judge_at = item.inspect?.judge_at

          item.contact_id = item.contact?.id
          item.employee_id = item.employee?.id
          return item
        }) || []

      } finally {
        this.loading--
        this.tableLoading = false
      }
    },
    async getChatDetail () {
      this.loading++
      try {
        let { code, data } = await violationChatDetail({
          contact_ids: this.contactIds,
          employee_ids: this.employeeIds,
          inspect_id: this.detail.id
        })
        if (code !== 200) {
          this.chatList = []
          return
        }
        this.chatList = data
        this.setMarkIdsToTable()
      } finally {
        this.loading--
      }
    },
    setMarkIdsToTable () {
      this.comfirmTableList.forEach(tableItem => {
        let inspection_situation = {}
        let chats = this.chatList
          .filter(chatItem => {
            let res = tableItem.contact_id == chatItem.contact?.id && tableItem.employee_id == chatItem.employee.id
            if (res) {
              chatItem.belongsTo = tableItem
              chatItem.type && (inspection_situation[chatItem.type] ? inspection_situation[chatItem.type] ++ : (inspection_situation[chatItem.type] = 1))
            }
            return res
          })
        tableItem.mark_ids = chats.map(item => item.id)
        this.$set(tableItem, 'inspection_situation', inspection_situation)
      })
    },
    async getInspectorsMap () {
      const { data, code } = await getLiveInspectors()
      if (code === 200) {
        let mapObj = {
          '-1': { realname: '取消稽查' }
        }
        data?.forEach(item => {
          mapObj[item.id] = item
        })
        this.$set(this, 'inspectorsMap', mapObj)
      }
    },
    onInspectorEdit () {
      this.inspectorEdit = true
      this.oldInspector = this.inspector
      this.$nextTick(() => {
        this.$refs['editSelect'].$el.click()
      })
    },
    async onInspectorChange() {
      if (this.modifyInspectOrderLoading) return
      if (this.inspector === this.oldInspector) {
        this.inspectorEdit = false
        return
      }
      try {
        let params = {
          user_id: this.inspector,
          order_id: this.detail.order_id,
          gold_coding: this.detail.gold_coding,
        }
        if (this.inspector == '-1') {
          params.user_id = ''
          await this.$confirm('确认取消稽查？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
        }
        this.modifyInspectOrderLoading = true
        const { code, msg } = await modifyInspectOrder(params)
        if (code !== 200) {
          this.$message.error(msg)
          throw new Error(msg)
        }
        this.$message.success('操作成功')
      } catch {
        // 恢复数据
        this.inspector = this.oldInspector
      } finally {
        this.inspectorEdit = false
        this.modifyInspectOrderLoading = false
        if(this.inspector == '-1') {
          // 取消状态下刷新页面
          this.init()
        }
      }
    },
    backToList() {
      import("@/modules/headBack/headBack").then(({ Back }) => {
        Back()
      })
    },
  }
}
</script>

<style lang="scss" module>
.outer {
  background-color: #fff;
  padding: 20px;
  min-height: 700px;
}
.top_warp {
  padding-bottom: 10px;
  border-bottom: 2px solid #EBEEF5;
}
.top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 14px;
  color: #101010;
}

.top__info {
  &>span {
    white-space: nowrap;
    margin-right: 25px;
  }
  // span + span {
  //   margin-left: 25px;
  // }
}
.top__right {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  i {
    margin: 0 5px;
  }
}
.top_assist_sales {
  display: flex;
  font-size: 14px;
  color: #101010;
  margin-top: 10px;
  line-height: 22px;
  span {
    white-space: nowrap;
  }
  .label {
    flex-shrink: 0;
  }
  
}
.editText {
  cursor: pointer;
  &:hover {
    color: #008080;
  }
}
i.editText {
  font-size: 20px;
}

.module {
  padding-top: 5px;
}
.module + .module {
  border-top: 2px solid #EBEEF5;
  margin-top: 20px;
}

.w80 {
  padding-right: 20%;
}
.moduleTitle {
  color: #101010;
  font-size: 18px;
  font-weight: 600;
  line-height: 36px;
  margin: 10px 0;
}

.btns {
  button {
    padding: 10px 50px!important;
  }
}
</style>